module.exports = "<!--<app-cedant-selector-view></app-cedant-selector-view>-->\n"